<template>
  <cxl-vbden-common
    :isOpen="isOpen"
    :quote="quote"
    :flowId="flowId"
    :stepId="stepId"
    :nextVbIncomingProcess="nextVbIncomingProcess"
    :isProcessing="isProcessing"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    @submit="submit"
    ref="cxlDialog"
  />
</template>
<script>
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import buildShortNameFilter from "../../../filters/buildShortNameFilter.js";
  import constants from "../../../constants";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import vbIncomingProcessService from "../../../services/vbIncomingProcessService";
  import handlersTreeMixin from "../../../mixins/handlersTreeMixin";
  import CxlVbdenCommon from "./cxl-vbden-common";
  import vbFlowInstanceService from "../../../services/vbFlowInstanceService";

  export default {
    name: "cxl-vbden-dialog",
    mixins: [handleRequestErrorMixin, handlersTreeMixin],
    filters: {buildShortNameFilter},
    props: ["isOpen", "quote", "incomingProcessId"],
    components: {
      CxlVbdenCommon,
      dialogTemplate: () => import("../../common/custom-dialog.vue"),
      chuyenXuLyHashtag: () => import("./chuyenXuLy-hashtag.vue"),
      VuePerfectScrollbar
    },

    data() {
      return {
        vbIncomingProcess: null,
        nextVbIncomingProcess: null,
        isProcessing: false,
        flowInstance: null
      };
    },

    watch: {},

    computed: {
      flowInstanceId() {
        return this.vbIncomingProcess
          ? this.vbIncomingProcess.flowInstanceId
          : null;
      },
      docId() {
        return this.vbIncomingProcess ? this.vbIncomingProcess.docId : null;
      },
      flowId() {
        return this.flowInstance ? this.flowInstance.flowId : null;
      },
      stepId() {
        return this.vbIncomingProcess ? this.vbIncomingProcess.stepId : null;
      }
    },

    created() {
      this.loadIncomingProcess()
        .then(() => this.loadNextVbIncomingProcesses())
        .then(() => this.loadFlowInstance())
        .then(() => this.$nextTick(() => this.$refs.cxlDialog.initForm()));
    },

    methods: {
      loadFlowInstance() {
        return vbFlowInstanceService
          .findById(this.flowInstanceId)
          .then(response => (this.flowInstance = response.data));
      },

      loadNextVbIncomingProcesses() {
        return vbIncomingProcessService
          .nextVbIncomingProcesses(this.incomingProcessId, this.docId)
          .then(response => (this.nextVbIncomingProcess = response.data));
      },

      loadIncomingProcess() {
        return vbIncomingProcessService
          .findById(this.incomingProcessId)
          .then(response => (this.vbIncomingProcess = response.data));
      },

      submit(event) {
        let processHandlerForms = event.handlersData
          .filter(item => item.stepType === constants.STEP.STEP_TYPE.CANHAN)
          .map(item => {
            let userDeptRole = item.userDeptRole;
            return {
              userId: userDeptRole.userId,
              deptId: userDeptRole.deptId,
              roleId: userDeptRole.roleId,
              positionId: userDeptRole.positionId,
              userDeptRoleId: userDeptRole.id,
              processType: item.processType,
              stepId: item.stepId
            };
          });

        let processHandlerDeptForms = event.handlersData
          .filter(item => item.stepType === constants.STEP.STEP_TYPE.DONVI)
          .map(item => {
            return {
              deptId: item.department.id,
              stepId: item.stepId,
              processType: item.processType
            };
          });

        let submitForm = {
          incomingProcessId: this.incomingProcessId,
          flowInstanceId: this.flowInstanceId,
          flowId: this.flowId,
          stepId: this.stepId,
          content: event.note,
          isAutoAssignTask: event.isAutoAssignTask,
          processHandlerForms: processHandlerForms,
          processHandlerDeptForms: processHandlerDeptForms,
          startDate: event.startDate,
          deadline: event.deadline,
          manday: event.manday,

        };

        this.isProcessing = true;
        vbIncomingProcessService
          .chuyenXuLi(submitForm, this.docId)
          .then(response => {
            this.$message({
              message: "Chuyển xử lý văn bản đến thành công",
              type: "success"
            });
            this.isProcessing = false;
            this.$emit("success", {vbIncomingProcess: response.data});
          })
          .catch(error => {
            this.isProcessing = false;
            return this.commonHandleRequestError(error);
          });
      }
    }
  };
</script>
<style scoped>
  .title {
    width: 100%;
  }

  .list-checkbox {
    position: relative;
    margin-right: 10px;
  }

  .scroll-list-user {
    height: auto;
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }

  .list-checkbox .item {
    width: 90px;
    text-align: center;
    margin: 0;
  }

  .icon-close {
    position: absolute;
    right: -5px;
    font-size: 18px;
  }

  .dialog-body .display-list__selected .list-selected .header > div {
    width: 100%;
  }

  .dialog-body .display-list__selected .list-selected .body {
    padding: 0;
  }

  .dialogTransferHandling .dialog-body .list-collapse__transfer {
    display: flex;
    flex-direction: column;
  }

  .dialogTransferHandling .dialog-body .scroll-area-height_90 {
    height: 100%;
    margin-bottom: 0;
    margin-right: -13px;
  }

  .dialog-body .display-list__selected {
    height: 400px;
  }

  .dialogTransferHandling .dialog-body .display-list__selected .list-selected {
    height: calc(100% - 121px);
  }

  .dialog-body .display-list__selected .list-selected .header {
    padding-left: 10px;
    padding-right: 10px;
  }

  .dialog-body .display-list__selected .list-selected .body .list-filter {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/cxl-vbden-dialog.vue